<template>
  <div>
    <el-dialog title="修改/新增发票" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
      <div slot="title" class="header-title">
        <span class="title-name">修改/新增发票</span>
        <el-checkbox v-model="form.isForeign" :true-label="1" :false-label="0" style="float:right;margin-right:30px;" v-if="form.invoiceType!==2">境外及港澳台公司</el-checkbox>
      </div>
      <div class="add_content" v-loading="loading">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="130px" class="demo-form">
          <el-form-item label="抬头类型">
            <el-radio-group v-model="type1">
              <el-radio :label="1">增值税电子普通发票</el-radio>
              <el-radio :label="2">增值税电子专用发票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="抬头类型" v-if="type1 === 1">
            <el-radio-group v-model="type2" @change="changeinvoiceType">
              <el-radio :label="1">公司</el-radio>
              <el-radio :label="2">个人</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.invoiceType==1 || form.invoiceType==3">
            <template v-if="form.isForeign === 1">
              <el-form-item label="公司名称" prop="invoiceTitle" key="1">
                <el-input v-model="form.invoiceTitle" style="width:460px;" maxlength="200" placeholder="请输入英文"></el-input>
              </el-form-item>
              <el-form-item label="国家及地区" prop="country" key="2">
                <el-input v-model="form.country" style="width:460px;" maxlength="200" placeholder="请输入英文"></el-input>
              </el-form-item>
              <el-form-item label="城市" prop="foreignCity" key="3">
                <el-input v-model="form.foreignCity" style="width:460px;" maxlength="200" placeholder="请输入英文"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="regAddress" key="4">
                <el-input v-model="form.regAddress" style="width:460px;" maxlength="200" placeholder="请输入英文"></el-input>
              </el-form-item>
              <el-form-item label="邮编" prop="postCode" key="5">
                <el-input v-model="form.postCode" style="width:460px;" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contact" key="6">
                <el-input v-model="form.contact" style="width:460px;" maxlength="200" placeholder="请输入英文"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="regPhone" key="7" class="is-required">
                <el-input v-model="form.regPhone" style="width:460px;" maxlength="50"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="公司名称" prop="invoiceTitle" key="101">
                <el-popover placement="bottom-start" width="460" trigger="manual" v-model="titleTipsVisible" popper-class="invoice-tips">
                  <div style="color:#ca4300;height:100px;" v-if="isCs">请输入至少3个文字，系统将自动匹配公司信息</div>
                  <div class="tips" v-else>
                    {{noList&&form.invoiceTitle.length > 3?'未匹配到信息，请继续或重新输入':'请输入至少4个文字，系统将自动匹配公司名称和税号'}}
                  </div>
                  <el-autocomplete :maxlength="200"
                                   slot="reference"
                                   style="width:460px;"
                                   ref="autocomplete"
                                   v-model="form.invoiceTitle"
                                   :fetch-suggestions="querySearchAsync"
                                   @select="handleSelect"
                                   @focus="titleFocus(true)"
                                   @blur="titleTipsVisible = false"
                                   @input="titleFocus(false)"
                                   placeholder=""
                                   highlight-first-item
                                   :trigger-on-focus="false" :popper-class="isCs?'company-popper':''">
                    <template slot-scope="{ item }">
                      <div class="autocomplete-item" v-if="isCs">
                        <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                        <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",") }}</span>
                        <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                        <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                      </div>
                      <div v-else style="font-size: 12px;line-height: 18px;padding: 9px 0 7px;">
                        <div style="color: #333;">{{item.name}}</div>
                        <div style="color: #878787;">税号：{{item.creditCode}}</div>
                      </div>
                    </template>
                  </el-autocomplete>
                </el-popover>
                <!--              <el-input v-model="form.invoiceTitle" maxlength="200" style="width:460px;" v-else></el-input>-->
              </el-form-item>
              <el-form-item label="税号" prop="taxNo" key="102">
                <div style="display: flex;justify-content: space-between;align-items: center;width: 460px;">
                  <el-popover placement="bottom-start" width="460" trigger="manual" v-model="noTipsVisible" v-if="isCs">
                    <div style="color:#ca4300;height:100px;">请输入至少5位编码，系统将自动匹配公司信息</div>
                    <el-autocomplete :maxlength="20"
                                     slot="reference"
                                     style="width:460px;"
                                     ref="autocomplete"
                                     v-model="form.taxNo"
                                     :fetch-suggestions="querySearchAsync1"
                                     @select="handleSelect"
                                     @focus="noFocus"
                                     @blur="noTipsVisible = false"
                                     @input="noFocus"
                                     placeholder=""
                                     highlight-first-item
                                     :trigger-on-focus="false" popper-class="company-popper">
                      <template slot-scope="{ item }">
                        <div class="autocomplete-item">
                          <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                          <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",") }}</span>
                          <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                          <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-popover>
                  <el-input v-model="form.taxNo" maxlength="20" style="width: 460px;" v-else></el-input>
                </div>
              </el-form-item>
              <el-form-item label="公司地址" prop="regAddress" key="103">
                <el-input v-model="form.regAddress" style="width:460px;" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item label="公司电话" prop="regPhone" key="104">
                <el-input v-model="form.regPhone" style="width:460px;" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item label="开户银行" prop="bankName" key="105">
                <el-input v-model="form.bankName" style="width:460px;" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item label="银行账号" prop="bankNumber" key="106">
                <el-input v-model="form.bankNumber" style="width:460px;" maxlength="30"></el-input>
              </el-form-item>
              <!--            <el-form-item label="营业执照" prop="frontImg" class="is-required img-item" v-if="imgRequired">-->
              <el-form-item label="营业执照" prop="frontImg" class="img-item" :class="{'is-required': imgRequiredShow}" style="margin-bottom: 32px;">
                <template v-if="form.frontImg">
                <span class="yingye-img">
                  <img :src="getImgUrl(form.frontImg[0].fileUrl)" alt="" @click="downloadFile(form.frontImg[0])">
                  <span class="del-icon" @click="delImg('frontImg', 'frontImg')"></span>
                </span>
                </template>
                <template v-if="form.backImg">
                <span class="yingye-img">
                  <img :src="getImgUrl(form.backImg[0].fileUrl)" alt="" @click="downloadFile(form.backImg[0])">
                  <span class="del-icon" @click="delImg('backImg', 'frontImg')"></span>
                </span>
                </template>
                <upload-file bindKey="frontImg"
                             :apiUrl="host.javaUrl"
                             :apis="apis"
                             :limit="1"
                             :type="1"
                             v-model="form.frontImg"
                             v-if="!form.frontImg"></upload-file>
                <upload-file bindKey="backImg"
                             :apiUrl="host.javaUrl"
                             :apis="apis"
                             :limit="1"
                             :type="1"
                             v-model="form.backImg"
                             v-if="!form.backImg"></upload-file>
<!--                <span v-if="showTips">
                发票信息已更改，请确保已上传相应的营业执照
              </span>-->
              </el-form-item>
              <!--            <el-form-item label="" prop="frontImg1" class="is-required img-item" v-if="imgRequired1">-->
<!--              <el-form-item label="" prop="" class="img-item" v-if="imgRequired1">
                <div slot="label" style="display: inline-block;">
                  盖公章的<br>开票资料
                </div>
                <template v-if="form.frontImg1">
                <span class="yingye-img">
                  <img :src="getImgUrl(form.frontImg1[0].fileUrl)" alt="" @click="downloadFile(form.frontImg1[0])">
                  <span class="del-icon" @click="delImg('frontImg1', 'frontImg1')"></span>
                </span>
                </template>
                <template v-if="form.backImg1">
                <span class="yingye-img">
                  <img :src="getImgUrl(form.backImg1[0].fileUrl)" alt="" @click="downloadFile(form.backImg1[0])">
                  <span class="del-icon" @click="delImg('backImg1', 'frontImg1')"></span>
                </span>
                </template>
                <upload-file :apiUrl="host.javaUrl" :apis="apis" bindKey="frontImg1" :limit="1" :type="1" v-model="form.frontImg1" v-if="!form.frontImg1"></upload-file>
                <upload-file :apiUrl="host.javaUrl" :apis="apis" bindKey="backImg1" :limit="1" :type="1" v-model="form.backImg1" v-if="!form.backImg1"></upload-file>
                <a v-if="!showTips1" style="text-decoration: underline;" href="https://publicfiles.sgsonline.com.cn/TIC/2022/06/%E5%BC%80%E7%A5%A8%E4%BF%A1%E6%81%AF%E5%8F%98%E6%9B%B4%E9%80%9A%E7%9F%A5%E4%B9%A6_1654571108512.docx">可以使用此参考模板编辑盖章后上传</a>
                <span style="position: absolute;line-height: 30px;" v-if="showTips1">
&lt;!&ndash;                <a style="text-decoration: underline;" href="https://publicfiles.sgsonline.com.cn/TIC/2022/06/%E5%BC%80%E7%A5%A8%E4%BF%A1%E6%81%AF%E5%8F%98%E6%9B%B4%E9%80%9A%E7%9F%A5%E4%B9%A6_1654571108512.docx">可以使用此参考模板编辑盖章后上传</a>&ndash;&gt;
                <span class="redColor">
                  发票信息已更改，请确保已上传相应的变更材料
                </span>
              </span>

              </el-form-item>-->
              <div class="check-notice" v-if="showNotice">
                <el-checkbox v-model="checkNotice"></el-checkbox>
                我已充分了解并确认<span class="redColor" style="cursor: pointer" @click="tipsVisible = true">《开具增值税发票确认书》</span>
              </div>
            </template>
          </div>
          <div v-if="form.invoiceType==2">
            <el-form-item label="姓名"
                          prop="invoiceTitle">
              <el-input v-model="form.invoiceTitle"
                        style="width:460px;"
                        minlength="2"
                        maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="联系电话"
                          prop="regPhone">
              <el-input v-model="form.regPhone"
                        style="width:460px;"
                        maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="taxNo">
              <el-input v-model="form.taxNo"
                        style="width:460px;"
                        maxlength="18"></el-input>
            </el-form-item>
          </div>
          <div style="text-align:center;">
            <el-button type="primary"
                       :loading="loading"
                       @click="submitForm('ruleForm')"
                       class="popup_content_submitButton sgs-edit-address-button sgs-button">保 存</el-button>
          </div>
        </el-form>
      </div>
      <el-dialog :visible.sync="imgDialogVisible"
                 :append-to-body="true">
        <img width="100%"
             :src="dialogImageUrl"
             alt="">
      </el-dialog>
    </el-dialog>
    <invoice-notice v-model="tipsVisible" :checkNotice.sync="checkNotice"></invoice-notice>
  </div>
</template>

<script>
import InvoiceNotice from "src/components/invoice/InvoiceNotice.vue";
import UploadFile from '../invoice/UploadPrivateFileOcr.vue'
import {host} from "src/config";
export default {
  name: "createInvoice",
  components: {
    InvoiceNotice,
    UploadFile
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    value: {
      type: Boolean,
      default: false
    },
    apis: {
      type: Object,
      default() {
        return {}
      },
    },
    env: {
      type: String,
      default: 'local'
    },
    isCs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg = /^[\d\s-+*#]+$/
      if (value && !reg.test(value.trim())) {
        return callback(new Error('格式错误'))
      } else if (this.form.isForeign === 1 && !value) {
        return callback(new Error('请输入电话'))
      } else {
        return callback()
      }
    }
    const validateImg = (rule, value, callback) => {
      const noImg = (!this.form.frontImg || !this.form.frontImg.length) && (!this.form.backImg || !this.form.backImg.length)
      if (noImg && this.form.invoiceType !== 2 && this.form.isForeign === 0 && this.imgRequired && this.form.invoiceTitle && this.form.taxNo) {
        this.loading = true
        this.apis.checkCompany({
          company: this.form.invoiceTitle,
          taxNo: this.form.taxNo,
        }).then(res => {
          this.loading = false
          this.imgRequiredShow = false
          callback()
        }).catch(e => {
          this.loading = false
          this.$message.closeAll()
          this.imgRequiredShow = true
          if (e && e.resultCode === '3050') {
            callback(new Error(e.resultMsg))
          } else {
            callback(new Error('企业信息在工商数据库中校验不通过，请核对信息或者提供客户营业执照/组织机构代码证等材料'))
          }
          this.$nextTick(() => {
            this.$message.error('请上传营业执照')
          })
        })
      } else {
        this.imgRequiredShow = false
        return callback()
      }
    }
    const validateImg1 = (rule, value, callback) => {
      if  ((!this.form.frontImg1 || !this.form.frontImg1.length) && (!this.form.backImg1 || !this.form.backImg1.length)) {
        return callback(new Error('请上传盖章的开票资料或变更通知书'))
      } else {
        return callback()
      }
    }
    //税号和身份证号验证
    const validateTaxNo = (rule, value, callback) => {
      if (this.form.invoiceType === 2) {
        const reg =
          /^(\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^[a-zA-Z]\d{6}\(\d\)$)|(^\d{8}$)/
        if (!reg.test(value)) {
          return callback(new Error('请输入正确的身份证号码'))
        } else {
          return callback()
        }
      } else {
        const reg = /^[\da-zA-Z]+$/
        if (this.form.isForeign !== 1 && ((value.length !== 15 && value.length !== 17 && value.length !== 18 && value.length !== 20) || !reg.test(value))) {
          return callback(
            new Error(
              '纳税人识别号应为15、17、18或20位的数字和英文字母组合，请确认您的输入是否正确'
            )
          )
        } else {
          if (!this.isLogin || this.isCs) { // 客服或未登录不用调接口
            callback()
            return
          }
          if (this.showNotice || this.qryNoticeTaxNo[value]) {
            callback()
            return
          }
          this.apis.checkTaxNo({ taxNo: value })
            .then((res) => {
              this.qryNoticeTaxNo[value] = true
              if (res.data.isSure === 0) {
                this.showNotice = true
              }
              callback()
            })
            .catch((e) => {
              this.showNotice = true
              callback()
            })
        }
      }
    }
    //银行账号限制
    const BankNumberValue = (rule, value, callback) => {
      const reg = /^[0-9\-]{1,30}$/
      if (value && !reg.test(value)) {
        return callback(new Error('请输入1-30个数字'))
      } else {
        return callback()
      }
    }
    const validateEnNum = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9`~!@#$%^&*()_+|}{":?><,./;'\[\]\\=-\s]+$/
      if (value && this.form.invoiceType!==2 && this.form.isForeign === 1 && !reg.test(value.trim())) {
        return callback(new Error('请输入英文字符数字'))
      } else {
        return callback()
      }
    }
    const validateEn = (rule, value, callback) => {
      const reg = /^[a-zA-Z`~!@#$%^&*()_+|}{":?><,./;'\[\]\\=-\s]+$/
      if (value && !reg.test(value.trim())) {
        return callback(new Error('请输入英文字符'))
      } else {
        return callback()
      }
    }
    // 全空格校验
    const validateEmpty = (rule, value, callback) => {
      if (value && !value.trim()) {
        return callback(new Error('请输入正确内容'))
      } else {
        return callback()
      }
    }
    return {
      type1: 1,
      type2: 1,
      host: host(this.env),
      titleTipsVisible: false,
      dialogVisible: false,
      form: {
        invoiceType: 1,
        invoiceTitle: '',
        taxNo: '',
        regAddress: '',
        regPhone: '',
        bankName: '',
        bankNumber: null,
      },
      rules: {
        invoiceTitle: [
          {
            required: true,
            message: '请输入',
          },
          { validator: validateEnNum }
        ],
        regPhone: [
          {
            required: false,
            message: '请输入电话',
          },
          { validator: validatePhone, }
        ],
        taxNo: [
          { required: true, message: '请输入' },
          { validator: validateTaxNo, trigger: 'blur' },
        ],
        backImg: [{ trigger: 'change', validator: validateImg }],
        frontImg: [{ trigger: 'change', validator: validateImg }],
        frontImg1: [{ trigger: 'change', validator: validateImg1 }],
        regAddress: [
          { required: true, message: '请输入地址' },
          { validator: validateEnNum },
        ],
        bankName: [
          { required: false, message: '请输入开户银行' },
          { min: 1, max: 200, message: '长度为1-200个字符', trigger: 'blur' },
        ],
        bankNumber: [
          { required: false, validator: BankNumberValue, trigger: 'blur' },
        ],
        country: [
          { required: true, message: '请输入国家及地区', trigger: 'change', },
          { validator: validateEn, trigger: 'change' },
        ],
        foreignCity: [
          { required: true, message: '请输入城市', trigger: 'change', },
          { validator: validateEn, trigger: 'change' },
        ],
        postCode: [
          { required: true, message: '请输入邮编', trigger: 'change', },
          { validator: validateEnNum, trigger: 'change' },
        ],
        contact: [
          { required: true, message: '请输入联系人' },
          { validator: validateEn },
        ],
      },
      noTipsVisible: false,
      imgRequired: true,
      showTips: false,
      imgRequired1: false,
      showTips1: false,
      showNotice: false,
      checkNotice: false,
      tipsVisible: false,
      loading: false,
      imgDialogVisible: false,
      dialogImageUrl: '',
      qryNoticeTaxNo: {},
      noList: false,
      oldActiveInvoice: {},
      imgRequiredShow: false
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    invoiceType() {
      if (this.type1 === 2) {
        return 3
      }
      if (this.type1 === 1 && this.type2 === 1) {
        return 1
      }
      if (this.type1 === 1 && this.type2 === 2) {
        return 2
      }
    },
  },
  watch: {
    isCs: {
      handler(val) {
        this.showNotice = !val
      },
      immediate: true
    },
    invoiceType(val) {
      this.form.invoiceType = val
    },
    value: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    },
    data: {
      handler(val) {
        this.imgRequired = true
        this.oldActiveInvoice = {}
        this.imgRequiredShow = false
        if (val.invoiceTitle) {
          if (val.invoiceType !== 2) {
            // 个人不取身份证照片
            this.form = this.getimgurllist(val)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
          // this.oldActiveInvoice = JSON.parse(JSON.stringify(this.form))
          if (val.invoiceType === 1) {
            this.type1 = 1
            this.type1 = 1
          }
          if (val.invoiceType === 2) {
            this.type1 = 1
            this.type2 = 2
          }
          if (val.invoiceType === 3) {
            this.type1 = 2
          }
        }
      },
      immediate: true
    },
    form: {
      handler(val) {
        this.imgRequired = false
        if (val.invoiceTitle !== this.oldActiveInvoice.invoiceTitle || val.taxNo !== this.oldActiveInvoice.taxNo) {
          this.imgRequired = true
        }
      },
      deep: true
    }
  },
  methods: {
    getimgurllist(data) {
      let val = JSON.parse(JSON.stringify(data))
      if (val.frontImg) {
        this.apis.getDownUrl({ fileId: val.frontImg })
          .then((res) => {
            let d = [
              {
                fileUrl: res.data.fileUrl,
                fileId: data.frontImg,
              },
            ]
            this.$set(val, 'frontImg', d)
          })
          .catch((e) => {})
      } else {
        this.$delete(val, 'frontImg')
      }
      if (val.backImg) {
        this.apis.getDownUrl({ fileId: val.backImg })
          .then((res) => {
            let d = [
              {
                fileUrl: res.data.fileUrl,
                fileId: data.backImg,
              },
            ]
            this.$set(val, 'backImg', d)
          })
          .catch((e) => {})
      } else {
        this.$delete(val, 'backImg')
      }
      val.otherFileList && val.otherFileList.forEach((v, index) => {
        this.apis.getDownUrl({ fileId: v.fileId })
          .then((res) => {
            v.fileUrl = res.data.fileUrl
            const key = index === 0 ? 'frontImg1' : 'backImg1'
            this.$set(val, key, [v])
          })
          .catch((e) => {})
      })
      return val
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    changeinvoiceType(val) {
      this.form.invoiceType = val
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
    },
    querySearchAsync(queryString, cb, isNo) {
      const queryLength = isNo ? 4 : 2
      if (queryString && queryString.length > queryLength) {
        const data = {}
        if (isNo) {
          data.taxRegistrationNumber = queryString
        } else {
          data.word = queryString
          data.customerName = queryString
        }
        this.apis.getCust(data).then(res => {
          let result = []
          if (res.data.items && res.data.items.length) {
            result = res.data.items || []
          }
          this.noList = !result.length
          if(!this.isCs) this.titleTipsVisible = this.noList
          cb(result)
        }).catch(e => {
          this.noList = true
          if(!this.isCs) this.titleTipsVisible = true
          cb([])
        })
      } else {
        cb([])
      }
    },
    handleSelect(item) {
      // 选中输入建议
      this.titleTipsVisible = false
      this.noTipsVisible = false
      if (this.isCs) {
        this.form.invoiceTitle = item.customerNameCn
        this.form.taxNo = item.taxRegistrationNumber
        this.form.regAddress = item.addressCn
        this.form.regPhone = item.telephone
        this.form.bankName = `${item.bankName}(${item.bankBranchName})`
        this.form.bankNumber = item.bankAccountNum
        this.form.bossNo = item.number
      } else {
        this.form.invoiceTitle = item.name
        this.form.taxNo = item.creditCode
      }
      this.form = Object.assign({}, this.form)
      this.oldActiveInvoice = JSON.parse(JSON.stringify(this.form))
      // this.listSource = false
      this.$nextTick(() => {
        this.imgRequired = false
        // this.imgRequired1 = false
        this.isSelect = true
      })
    },
    titleFocus(isFocus) {
      if (isFocus) this.noList = false
      const num = this.isCs ? 3 : 4
      this.titleTipsVisible = !this.form.invoiceTitle || this.form.invoiceTitle.length < num
    },
    querySearchAsync1(queryString, cb) {
      this.querySearchAsync(queryString, cb, true)
    },
    noFocus() {
      this.noTipsVisible = !this.form.taxNo || this.form.taxNo.length < 5
    },
    getImgUrl(fileUrl) {
      if (!/\.(pdf|PDF)/.test(fileUrl)) {
        return fileUrl
      }
      return this.pdfIcon
    },
    // 预览发票图片
    downloadFile(data) {
      this.$set(data, 'downLoading', true)
      this.apis.getDownUrl({ fileId: data.fileId })
        .then((res) => {
          data.downLoading = false
          if (!/\.(pdf|PDF)/.test(res.data.fileUrl)) {
            this.dialogImageUrl = res.data.fileUrl
            this.imgDialogVisible = true
          } else {
            window.open(res.data.fileUrl)
          }
        })
        .catch((e) => {
          data.downLoading = false
        })
    },
    delImg(key, key1) {
      this.$delete(this.form, key)
      // this.validateImg(key1)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.isForeign !== 1 && this.showNotice && !this.checkNotice && this.form.invoiceType !== 2) {
            this.loading = false
            this.tipsVisible = true
            return
          }
          let data = {}
          if (this.form.invoiceType === 2) {
            data = {
              invoiceTitle: this.form.invoiceTitle,
              regPhone: this.form.regPhone,
              taxNo: this.form.taxNo,
              invoiceType: this.type1 === 2 ? 3 : this.type2,
            }
          } else {
            if (this.form.isForeign === 1) {
              data = {
                country: this.form.country,
                foreignCity: this.form.foreignCity,
                regAddress: this.form.regAddress,
                postCode: this.form.postCode,
                contact: this.form.contact,
                regPhone: this.form.regPhone,
                invoiceType: this.form.invoiceType,
                isForeign: this.form.isForeign,
                invoiceTitle: this.form.invoiceTitle,
              }
            } else {
              data = {
                invoiceType: this.type1 === 2 ? 3 : this.type2,
                invoiceTitle: this.form.invoiceTitle,
                taxNo: this.form.taxNo,
                regAddress: this.form.regAddress,
                regPhone: this.form.regPhone,
                bankName: this.form.bankName,
                bankNumber: this.form.bankNumber,
                invoiceId: this.form.invoiceId,
                isDefault: this.form.isDefault,
                bossNo: this.form.bossNo,
                isForeign: this.form.isForeign
              }
              data.backImg = this.form.backImg
                ? this.form.backImg.map((v) => v.fileId).join(',')
                : ''
              data.frontImg = this.form.frontImg
                ? this.form.frontImg.map((v) => v.fileId).join(',')
                : ''
              data.otherFileList = []
              if (this.form.frontImg1 && this.form.frontImg1.length) {
                data.otherFileList.push(this.form.frontImg1[0])
              }
              if (this.form.backImg1 && this.form.backImg1.length) {
                data.otherFileList.push(this.form.backImg1[0])
              }
            }
          }
          data.isEdit = this.isedit
          this.dialogVisible = false
          this.$emit('input', false)
          this.$emit('update:data', data)
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.del-icon {
  position: absolute;
  width: 16px;
  height: 16px;
  background: url('../../assets/images/delEmail.png');
  top: 2px;
  right: 2px;
  cursor: pointer;
  z-index: 1;
}
.check-notice {
  margin: 30px 0 20px 130px;
}
.yingye-img {
  display: inline-block;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  text-align: center;
  margin-right: 20px;
  position: relative;
  float: left;
}
.yingye-img img {
  /*width: 40px;
    height: 58px;*/
  max-height: 58px;
  max-width: 58px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.upload-file {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 10px;
}
.sfz-img {
  width: 60px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  text-align: center;
  /*margin-right: 13px;*/
  display: block;
  position: relative;
}
.sfz-img img {
  /*width: 55px;*/
  /*height: 34px;*/
  /*margin-top: 13px;*/
  max-height: 58px;
  max-width: 58px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>